import { dotToObject } from '@n2-common/lib/utils';
import { type AnySchema, object } from 'yup';

export type SchemaTree = {
    [key: string]: AnySchema | SchemaTree;
};

export type SchemaEntry = [key: string, schema: AnySchema];

export function fromEntries(entries: SchemaEntry[]) {
    return fromTree(Object.fromEntries(entries));
}

export function fromTree(tree: SchemaTree): AnySchema {
    return object().shape(
        Object.entries(tree).reduce((mem, [key, schemaOrTree]) => {
            if (isSchema(schemaOrTree)) {
                return { ...mem, [key]: schemaOrTree };
            } else {
                return { ...mem, [key]: fromTree(schemaOrTree) };
            }
        }, {})
    );
}

export function fromRawSchemas(rawSchemas: Record<string, AnySchema>[]){
    const combinedRawSchemas = rawSchemas.reduce((mem, leaf) => ({ ...mem, ...leaf}), {});
    const tree = dotToObject(combinedRawSchemas);
    const schema =  fromTree(tree);
    //console.log(schema);
    return schema;
}

function isSchema(schemaOrTree: AnySchema | SchemaTree): schemaOrTree is AnySchema {
    return schemaOrTree && ('validateAt' in schemaOrTree) && typeof schemaOrTree.validateAt == 'function';
}
